import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import {
  ApiCrearUsuarioTipoConRango,
  ApiEditarUsuarioTipoConRango,
  ApiActualizarUsuariosSegunRangoCode,
} from "../../../api/usuariosTipos";
import { ApiGetAllUsers } from "../../../api/usuarios";
import ModalDefault from "../../modalDefault";
import { Center, RingProgress, Text, ThemeIcon } from "@mantine/core";
import { FaCheckCircle, FaQuestion } from "react-icons/fa";
const CrearRangos = ({
  updateListFn,
  state,
  setState,
  type,
  setType,
  resetState,
}) => {
  const [loading, setlLoading] = useState(false);
  const [paginatedata, setPaginateData] = useState([]);

  const [showModalPassword, setShowModalPassword] = useState(false);

  const [mensaje, setmensaje] = useState(
    "Datos confirmados, ¿Desea sincronizar los rangos de los usuarios?"
  );
  const [progress, setProgress] = useState({ completed: 0, total: 0 });
  const [loaderData, setLoaderData] = useState(false);

  const fields = [
    { name: "tipo", label: "Tipo de usuario" },
    { name: "rango_init", label: "Rango inicial" },
    { name: "rango_end", label: "Rango final" },
  ];

  const onchange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    init();
  }, []);
  const init = async () => {
    const { data } = await ApiGetAllUsers();
    const filterUsers = data.filter(
      (user) => user.estado !== false && user.code !== null
    );
    /*     console.log(filterUsers)
     */ // Usando mapas para evitar duplicados
    const pushdata = [];
    const pagesdata = Math.ceil(filterUsers.length / 25);
    for (let index = 1; index <= pagesdata; index++) {
      const paginate2 = paginate(data, index, 25);
      pushdata.push(paginate2);
    }

    setPaginateData(pushdata);
  };

  const actualizarUsuariosPorrangos = async () => {
    const { data } = await ApiGetAllUsers();
    const filterUsers = data.filter(
      (user) =>
        user.estado !== false && (user.code !== null || user.code !== "")
    );
    setProgress({ completed: 0, total: filterUsers.length });
    setLoaderData(true);
    setmensaje("Sinconizando usuarios, por favor espere...");
    for (let index = 0; index < filterUsers.length; index++) {
      console.log(data[index].code);
      const sms = await ApiActualizarUsuariosSegunRangoCode({
        pre_usuario_id: data[index].pre_usuario_id,
        code: data[index].code,
      });

      setProgress((prev) => ({
        ...prev,
        completed: prev.completed + 1,
      }));
    }
    setmensaje("Sincronización de usuarios completada");
  };

  const paginate = (items, page, perPage) => {
    const offset = perPage * (page - 1);
    const totalPages = Math.ceil(items.length / perPage);
    const paginatedItems = items.slice(offset, perPage * page);

    return {
      previousPage: page - 1 ? page - 1 : null,
      nextPage: totalPages > page ? page + 1 : null,
      total: items.length,
      totalPages: totalPages,
      items: paginatedItems,
      actualPage: page,
    };
  };

  const emptyFields = fields.filter((campo) => !state[campo.name]);
  const CrearFn = async () => {
    setlLoading(true);
    if (emptyFields.length > 0) {
      const mensajes = emptyFields.map(
        (campo) => `El campo "${campo.label}" no puede estar vacío.`
      );
      const mensajeError = mensajes.join("\n");
      toast.error(mensajeError, {
        position: "bottom-center",
        style: {
          border: "1px solid red",
          padding: "16px",
          color: "white",
          background: "red",
          borderColor: "white",
        },
        iconTheme: {
          primary: "red",
          secondary: "white",
        },
      });
      setlLoading(false);
      return;
    }

    const res =
      type === "save"
        ? await ApiCrearUsuarioTipoConRango(state)
        : await ApiEditarUsuarioTipoConRango(state);
    const datares = res;
    if (datares.sms === "ok") {
      toast.success(datares.mensaje, {
        position: "bottom-left",
        style: {
          border: "1px solid green",
          padding: "16px",
          color: "white",
          background: "green",
          borderColor: "white",
        },
        iconTheme: {
          primary: "green",
          secondary: "white",
        },
      });
      setType("save");
      resetState();
      updateListFn();
    } else {
      toast.error(datares.mensaje, {
        position: "bottom-left",
        style: {
          border: "1px solid red",
          padding: "16px",
          color: "white",
          background: "red",
          borderColor: "white",
        },
        iconTheme: {
          primary: "red",
          secondary: "white",
        },
      });
    }
    setlLoading(false);
  };
  const onShowModalPassword = (e) => {
    setShowModalPassword(true);
  };

  const onClosedModalPassword = () => {
    setShowModalPassword(false);
    setProgress({ completed: 0, total: 0 });
    setmensaje(
      "Datos confirmados, ¿Desea sincronizar los rangos de los usuarios?"
    );
    setLoaderData(false);
  };
  return (
    <div>
      <div className="row mt-3 mb-4">
        <div className="col-md-6 col-lg-4  w-100">
          <div
            className=" bg-white  border-0 borde-tarjeta"
            style={{ height: "auto" }}
          >
            <div className="card-body m-0 p-0">
              <div className="w-100 bgfondo2 bordeabajo bordesombreado d-flex flex-column align-items-center d-flex justify-content-center py-3 px-3">
                <div className="w-100  d-flex justify-content-between align-items-center px-3">
                  <h5 className=" negrita card-title">
                    {type === "save" ? "Crear" : "Editar"} Tipo de usuarios
                  </h5>
                  <div className="d-flex justify-content-between flex-row align-self-start">
                    <div className="d-flex justify-content-end ">
                      {loading ? (
                        <div className="spinner-border" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                      ) : (
                        <button
                          type=""
                          className="bg-btn-vet bordesombreado"
                          onClick={() => CrearFn()}
                        >
                          <i className="fas fa-save mx-2"></i>
                          {type === "save" ? "Guardar" : "Editar"} Tipo de
                          usarios
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="row py-4 ">
                <div className="col-md-6">
                  <label className="py-2 negrita">Tipo de usuario</label>
                  <input
                    type="text"
                    id="tipo"
                    name="tipo"
                    value={state.tipo}
                    className="inputtext2 bordecompleto"
                    placeholder="Digite tipo de usuario"
                    onChange={onchange}
                  />
                </div>
                <div className="col-md-6">
                  <label className="py-2 negrita">Codigo tipo</label>
                  <input
                    type="text"
                    id="code"
                    name="code"
                    value={state.code}
                    className="inputtext2 bordecompleto"
                    placeholder="Digite tipo de usuario"
                    onChange={onchange}
                  />
                </div>
                <div className="col-md-6">
                  <label className="py-2 negrita">
                    Rango inicial del código
                  </label>
                  <input
                    type="number"
                    id="rango_init"
                    name="rango_init"
                    value={state.rango_init}
                    className="inputtext2 bordecompleto"
                    placeholder="Digite número inicial del rango"
                    onChange={onchange}
                  />
                </div>
                <div className="col-md-6">
                  <label className="py-2 negrita">Rango final del código</label>
                  <input
                    type="number"
                    id="rango_end"
                    name="rango_end"
                    value={state.rango_end}
                    className="inputtext2 bordecompleto"
                    placeholder="Digite número final del rango"
                    onChange={onchange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="row py-2">
        <button
          type=""
          onClick={() => {
            onShowModalPassword();
            //init();
          }}
        >
          Verifica rangos en nómina
        </button>
      </div> */}
      <ModalDefault
        bandera={"confirmacion"}
        modal={showModalPassword}
        size={"md"}
        titulo={`Sincronizacion de rangos`}
        closeAction={onClosedModalPassword}
      >
        <div>
          <Text align="center">{mensaje}</Text>
          <Center>
            <div className="d-flex flex-column">
              {progress.completed !== progress.total ? (
                <RingProgress
                  sections={[
                    {
                      value: (progress.completed / progress.total) * 100,
                      color: "blue",
                    },
                  ]}
                  label={
                    <Text color="blue" weight={700} align="center" size="sm">
                      {progress.completed}/{progress.total}
                    </Text>
                  }
                />
              ) : loaderData ? (
                <RingProgress
                  sections={[{ value: 100, color: "teal" }]}
                  label={
                    <Center>
                      <ThemeIcon
                        color="teal"
                        variant="light"
                        radius="xl"
                        size="xl"
                      >
                        <FaCheckCircle size={22} />
                      </ThemeIcon>
                    </Center>
                  }
                />
              ) : (
                <RingProgress
                  sections={[
                    {
                      value: 0,
                      color: "gray",
                    },
                  ]}
                  label={
                    <Center>
                      <ThemeIcon
                        color="gray"
                        variant="light"
                        radius="xl"
                        size="xl"
                      >
                        <FaQuestion size={22} />
                      </ThemeIcon>
                    </Center>
                  }
                />
              )}
            </div>
          </Center>
        </div>
        <div className="d-flex justify-content-end flex-row align-self-start my-4">
          <button
            type=""
            onClick={onClosedModalPassword}
            className="bg-btn-vet-danger sombra mx-1"
            disabled={loaderData}
          >
            Cerrar
          </button>
          <button
            type=""
            onClick={() => actualizarUsuariosPorrangos()}
            className="bg-btn-vet sombra mx-1"
            disabled={loaderData}
          >
            <i className="fas fa-sync-alt mx-2"></i> Sincronizar usuarios
          </button>
        </div>
      </ModalDefault>
    </div>
  );
};

export default CrearRangos;
